// Одно правило на весь дашборд мэтчинга: депозиты синие, выплаты зелёные.
// Эталон — график «Динамика депозитов, выплат и конверсии», который так и был
// покрашен; корзины и «Непокрытый спрос» подтянуты к нему.
//
// Держать пару здесь обязательно: раньше каждый блок объявлял свой массив
// цветов, и именно поэтому три блока разъехались в три разные схемы — на одном
// синий значил депозиты, на другом выплаты, на третьем депозиты были красными.
export const SERIES_COLOR = {
  deposit: '#009EF7',
  payout: '#50CD89',
} as const

// Кубики и колонки красят не одним цветом, а ступенью насыщенности, поэтому им
// нужны рампы. Обе построены по одной кривой светлоты от базового тона своей
// серии (синий 205°, зелёный 145°), так что кубики и колонки читаются в одном
// тоне, а средняя ступень каждой рампы совпадает с базовым цветом серии.
export const DEPOSIT_RAMP = ['#B7DDF9', '#6BBCF3', '#009EF7', '#0A76BC', '#0B4E7C']
export const PAYOUT_RAMP = ['#C2EAD3', '#87D8AC', '#50CD89', '#2F9C64', '#1D6842']

/** Чернила подписи по ступени рампы: тёмные на светлых ступенях, белые на глубоких. */
export const RAMP_INK = ['#3F4254', '#3F4254', '#FFFFFF', '#FFFFFF', '#FFFFFF']
